export enum PayrollStatus {
  ALL = "All",
  DRAFT = "Draft",
  APPROVED = "Approved",
  PAID = "Paid",
}

export const PAYROLL_STATUS_OPTIONS = [
  { label: "All Statuses", value: PayrollStatus.ALL },
  { label: "Draft", value: PayrollStatus.DRAFT },
  { label: "Approved", value: PayrollStatus.APPROVED },
  { label: "Paid", value: PayrollStatus.PAID },
];

export interface PayrollRecord {
  id: string;
  payroll_number?: string;
  payroll_month: string;
  employee_id: string;
  employee_name?: string;
  basic_salary: number;
  gross_salary: number;
  net_salary: number;
  total_additions: number;
  total_deductions: number;
  status: PayrollStatus | string;
  created_at?: string;
  approved_by?: string;
  paid_at?: string;
}
